// extracted by mini-css-extract-plugin
export var collapsedSummary = "_nh-0";